import React from 'react';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@material-ui/core/Switch';

import { makeStyles } from '../styles';

interface SwitchProps extends MuiSwitchProps {
  label?: React.ReactNode;
  labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
  size?: 'small' | 'medium';
}

export const Switch: React.FC<SwitchProps> = props => {
  const classes = useSwitchStyles(props);
  return (
    <FormControlLabel
      control={
        <MuiSwitch
          classes={{
            root: classNames(classes.root, { [classes.disabled]: props.disabled }),
            switchBase: classes.switchBase,
            checked: classes.checked,
            thumb: classes.thumb,
            track: classes.track,
            disabled: classes.disabled,
          }}
          size={props?.size || 'medium'}
          checked={props.checked}
          disabled={props.disabled}
          onChange={props.onChange}
        />
      }
      label={props.label}
      labelPlacement={props.labelPlacement}
    />
  );
};

const useSwitchStyles = makeStyles(theme => {
  return {
    root: {
      width: 24,
      height: 16,
      padding: '5px 0',
      '& span': {
        padding: 0,
      },
      '&$disabled': {
        opacity: 0.5,
      },
    },
    disabled: {},
    checked: {},
    switchBase: {
      padding: '2px 0 !important',
      '&$checked': {
        transform: 'translateX(12px)',
      },
      '&$checked $thumb': {
        backgroundColor: theme.colors.blue,
      },
      '&$checked + $track': {
        backgroundColor: `${theme.colors.blue} !important`,
        opacity: 0.5,
      },
      ...theme.overrides?.MuiSwitch?.switchBase,
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
      backgroundColor: theme.colors.gray50,
    },
    track: {
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.colors.gray20,
    },
  };
});

export default Switch;
